<template>
  <div style="height:100vh;display:flex;flex-direction:column;">
    <!-- 固定头部 -->
    <div style="position:fixed;top:0;left:0;right:0;background:#F7F8FA;height:56px;border-bottom:1px solid #EBEDF0;z-index:999;display:flex;align-items:center;padding:0 12px;">
      <!-- 返回按钮 -->
      <div @click="onClickLeft" style="width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;">
        <van-icon name="arrow-left" size="20" color="#333333" style="font-weight:600;" />
      </div>

      <!-- 搜索框 -->
      <div style="flex:1;margin:0 12px;">
        <div style="background:#FFFFFF;border-radius:15px;border:1px solid #E5E5E5;height:30px;display:flex;align-items:center;padding:0 12px;">
          <van-icon name="search" size="14" color="#999999" style="margin-right:6px;" />
          <input
              v-model="v_search"
              placeholder="搜索订单号"
              style="border:none;outline:none;background:transparent;flex:1;font-size:13px;color:#333333;height:100%;"
              @keyup.enter="onSearch"
          />
        </div>
      </div>

      <!-- 右侧按钮组 -->
      <div style="display:flex;gap:8px;align-items:center;flex-shrink:0;">
        <div @click="onSearch" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
          <van-icon name="search" size="14" color="#1ECD84" />
        </div>
        <div @click="onScan" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
          <van-icon name="scan" size="14" color="#235EFF" />
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div style="flex:1;overflow-y:auto;background:#F7F8FA;margin-top:56px;padding-bottom:60px;">
      <div style="padding: 12px;">
        <div v-for="(item,index) in tabData" :key="index" class="order-card" @click="handleView(item)">
          <!-- 卡片头部 -->
          <div class="card-header">
            <div class="card-title">生产订单：{{item.ORDNO}}</div>
            <!-- <div class="card-status" :class="getStatusClass(item.ORDSTFG)">
              {{item.STFGNM}}
            </div> -->
          </div>

          <!-- 卡片内容 -->
          <div class="card-content">
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">产品编码</span>
                <span class="info-value">{{item.SUPIDNO}}</span>
              </div>
            </div>
             <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">产品名称</span>
                <span class="info-value">{{item.MATNM}}</span>
              </div>
            </div>
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">订单数量</span>
                <span class="info-value">{{item.QTY}}</span>
              </div>
              <div class="info-row">
                <span class="info-label">生产数量</span>
                <span class="info-value">{{item.PCQTY}}</span>
              </div>
            </div>
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">交货日期</span>
                <span class="info-value">{{item.SHPDTTM}}</span>
              </div>
            </div>
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">审核日期</span>
                <span class="info-value">{{item.CHKDTTM}}</span>
              </div>
            </div>
          </div>

          <!-- 卡片底部操作按钮 -->
          <div class="card-actions">
            <van-button 
              class="action-btn action-btn-view" 
              size="small"
              @click.stop="handleView(item)"
              :style="{ background: '#235EFF', color: '#FFFFFF', border: 'none' }"
            >
              <span>查看报工</span>
            </van-button>
          </div>
        </div>
        
        <!-- 空状态 -->
        <div v-if="tabData.length === 0" class="empty-state">
          <van-icon name="orders-o" size="48" color="#CCCCCC" />
          <p>暂无订单数据</p>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div style="border-top:1px solid #EBEDF0;background:#FFFFFF;position:fixed;bottom:0;left:0;right:0;z-index:100;">
      <van-pagination v-model="currentPage" :total-items="v_total" :items-per-page="rowSize" :show-page-size="5" force-ellipses @change="changePage">
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
    </div>

    <!-- 扫码组件 -->
    <ScanCode
      :visible.sync="showScan"
      @success="handleScan"
    />

  </div>
</template>

<script>
import ScanCode from "@/components/common/ScanCode.vue";
import {getBaseData,getTabColOrData} from '@/api/user';
export default {
  name: "WorkshopReport",

  components: {
    ScanCode
  },

  data() {
    return {
      v_search: '',
      v_cond: '',
      tabData: [],
      allData: [],
      v_total: 0,
      rowSize: 10,
      currentPage: 1,
      scroll: 0,
      topShow: false,
      
      v_username: this.$cookies.get('v_telno'),
      v_corpid: this.$cookies.get('v_corpid'),
      v_usernm: this.$cookies.get('v_usernm'),
      v_url: 'xuper_auth/getTableRecMany',
      
      // 扫码
      showScan: false
    };
  },

  mounted() {
    window.addEventListener("scroll", this.windowScroll)
    
    if (this.v_username) {
      // 初始加载查询未审核的订单，按订单号倒序排列
      this.getTabList(" and STFG = 'N' order by ORDNO desc")
    } else {
      this.$router.push({ path: '/login' })
    }
  },

  // 监听路由变化，从详情页返回时刷新数据
  watch: {
    $route(to, from) {
      if (from.path.includes('/workshopReport/detail')) {
        // 从详情页返回，刷新列表数据
        this.getTabList(" and STFG = 'N' order by ORDNO desc")
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.windowScroll)
  },

  methods: {
    // 返回
    onClickLeft() {
      this.$router.push({ path: '/features' })
    },

    // 搜索
    onSearch() {
      let v_cond = ''
      if (this.v_search) {
        // 搜索订单号（生产订单），忽略大小写
        v_cond = " and lower(ORDNO) like '%" + this.v_search.toLowerCase() + "%'"
      }
      // 默认查询未审核的订单，按订单号倒序排列
      v_cond += " and STFG = 'N' order by ORDNO desc"
      this.currentPage = 1
      this.getTabList(v_cond)
    },

    // 扫码
    onScan() {
      this.showScan = true
    },

    // 扫码成功回调
    handleScan(code) {
      console.log("扫码结果", code)
      this.showScan = false
      
      // 扫码返回的是订单ID，根据ID查询订单
      this.v_search = code
      this.onSearch()
    },

    // 分页
    changePage(index) {
      var _start = (index - 1) * this.rowSize;
      var _end = index * this.rowSize;
      this.tabData = this.allData.slice(_start, _end);
    },
        //明细查询
    getTabList(cond_) {
      this.tabData = []
      getTabColOrData(this.v_url,'V_ORD_PROC','','','corpid',this.v_corpid,'','',cond_).then((res) => {
        if (res.code=='200'){
          this.allData = res.result
          this.v_total = res.result.length
          this.initPage()
        }else{
          this.$notify({ type: 'warning', message: res.result})
        }
      })
    },

    // 初始化分页
    initPage() {
      if (this.allData.length < this.rowSize) {
        this.tabData = this.allData
      } else {
        this.tabData = this.allData.slice(0, this.rowSize)
      }
    },

    // 获取状态样式
    getStatusClass(status) {
      console.log(status, 'status')
      const statusMap = {
        'N': 'status-processing',
        'Y': 'status-done'
      }
      return statusMap[status] || 'status-default'
    },

    // 查看报工详情
    handleView(item) {
      this.$router.push({
        path: '/workshopReport/detail',
        query: {
          id: item.IDSEQ,
          orderno: item.ORDNO
        }
      })
    },

    // 滚动监听
    windowScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      this.scroll > 300 ? (this.topShow = true) : (this.topShow = false);
    }
  },
};
</script>

<style lang="scss" scoped>
// 订单卡片样式
.order-card {
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #F0F0F0;
  
  .card-title {
    font-size: 15px;
    font-weight: 600;
    color: #333333;
    flex: 1;
  }
  
  .card-status {
    font-size: 12px;
    line-height: 20px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
    
    &.status-pending {
      background: rgba(253, 199, 28, 0.1);
      color: #FDC71C;
    }
    
    &.status-processing {
      background: rgba(35, 94, 255, 0.1);
      color: #235EFF;
    }
    
    &.status-done {
      background: rgba(30, 205, 132, 0.1);
      color: #1ECD84;
    }
    
    &.status-default {
      background: rgba(102, 102, 102, 0.1);
      color: #666666;
    }
  }
}

.card-content {
  padding: 10px 12px;
  
  .info-row-wrapper {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .info-row {
    display: flex;
    flex: 1;
    min-width: 0;
    font-size: 14px;
    line-height: 22px;
    
    .info-label {
      color: #666666;
      font-size: 14px;
      min-width: 70px;
      flex-shrink: 0;
    }
    
    .info-value {
      color: #333333;
      font-size: 14px;
      flex: 1;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid #F0F0F0;
  
  .action-btn {
    height: 28px;
    padding: 0 16px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.action-btn-view {
      background: #235EFF !important;
      color: #FFFFFF !important;
    }
  }
}

// 空状态
.empty-state {
  padding: 60px 0;
  text-align: center;
  
  p {
    margin-top: 12px;
    color: #999999;
    font-size: 14px;
  }
}

// 覆盖 van-pagination 样式
::v-deep .van-pagination {
  padding: 12px 0;
  background: #FFFFFF;

  .van-pagination__item {
    border-radius: 8px;
    color: #666666;
    font-size: 14px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;

    &--active {
      background: #235EFF;
      color: #FFFFFF;
    }
  }
}
</style>
